module.exports = "../../fonts/vendor/@mdi/materialdesignicons-webfont.eot?de316c4d7c49351893235ebee55a9756";